import { AdvancedSearchService } from '../../searchBar/advancedSearch.service';
import {Cheetah} from "../../../search/cheetah.service";
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {ResultUtil} from "../../../nddUtils/resultUtil.service";
import {Component, Inject, Input} from 'ng-metadata/core';
import {PersonEntityPageService} from "./personEntityPage.service";
import {PrimolyticsService, beacon} from "../../../analytics/primolytics.service";
import {LinkedDataService} from "../linkedData/linkedData.service";
import {LinkedDataModel} from "../linkedData/linkedDataModel";
import {MediaQueries} from "../../../infra/mediaQueries.service";
import { PagesTitlesService } from '../../../infra/accessibility/pagesTitles.service';
import {SearchResultThumbnailContainerService} from "../../../search/searchResult/searchResultThumbnail/searchResultThumbnailContainer.service";
import {getSearchScopesMap, updateSearchScopesMap, getVid, getFindInDbPerTabs,
    isAutoSearchOnTabChange, getInstitutionCode, getChosenKeepMeSignInConf, getPersonEntityAutocompleteUrl, getEnablePersonEntityAutocomplete
} from '../../../appConfig/appConfigForward';
import {WindowInfoUtils} from "../../../nddUtils/windowInfoUtils.service";


const has= require('lodash/has');
const uniqBy = require('lodash/uniqBy');
const get= require('lodash/get');
const find= require('lodash/find');
const forEach = require('lodash/forEach');
const isEmpty = require('lodash/isEmpty');
const sortBy = require('lodash/sortBy');
const isEqual = require('lodash/isEqual');

@Component({
    selector: 'prm-person-entity-page',
    templateUrl: 'components/search/fullView/personEntityPage/person-entity-page.html',
})

export class PrmPersonEntityPage {
    private personId: string;
    private institutionId: string;
    private vid: string;
	private data: LinkedDataModel;
	private linkedDataResponse;
	private allItemThumbnailLinksPromisesArray = [];
    private WIKIPEDIA_API_URL = 'https://en.wikipedia.org/w/api.php?action=query&utf8=&format=json&origin=*&explaintext&exsentences=5&exsectionformat=plain&prop=extracts&titles=';
    private SYNDETICS_THUMBNAIL_BASE_URL = 'https://syndetics.com/index.php?client=primo';
    private personFieldsToDisplay = [{name:'dateOfBirth'},{name:'dateOfDeath'},{name:'fieldOfWork'},{name:'occupation'},{name:'source'}];
    private personPnxFields = ['originatingSystemIDContributor','originatingSystemIDSubject','originatingSystemIDAuthor'];
    private personRelatedDataSectionsArray = [];    
    private relatedPersonsIds = [];    
    private relatedPersonsSection = {}; 
    private _sourceTranslation = '';  
    private COPYRIGHT_LICENSE_URL = 'https://creativecommons.org/licenses/by/4.0/deed.en';

    constructor(private personEntityPageService: PersonEntityPageService,
                private primolyticsService: PrimolyticsService,
                private mediaQueries: MediaQueries,
                private advancedSearchService: AdvancedSearchService,
                private resultUtil: ResultUtil,
		        private pagesTitlesService: PagesTitlesService,
                private searchResultThumbnailContainerService: SearchResultThumbnailContainerService,
                private cheetah: Cheetah,
                private windowInfoUtils : WindowInfoUtils,
		        @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('restBaseURLs') private restBaseURLs,
				@Inject('$q') private $q: ng.IQService,
				@Inject('$translate') private $translate: ng.translate.ITranslateService,
				@Inject('$http') private $http: angular.IHttpService,
				@Inject('$timeout') private $timeout: ng.ITimeoutService,
				@Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService){
		this.personId = $stateParams['personId'];
		this.institutionId = $stateParams['inst'] || getInstitutionCode();
		this.institutionId = $stateParams['vid'] || getVid();					
        this.advancedSearchService.setSessionAdvancedSearchMode('collapsed');
        this.personRelatedDataSectionsArray = this.getPersonRelatedDataSectionsArray(this.personId);
        this.getPersonApiData({requestType: 'relatedPersons',ids: [{id:this.personId, type:'author'}]}).then((response) => {this.handlePersonApiData(response);});

        this.getPersonRelatedDataSectionsData(this.personId);        
    }

    ngOnInit(){
        this.$translate('nui.personEntity.sourceText').then((translation) =>
                this.sourceTranslation = translation);
    }

	private getPersonApiData(payload) {
        let httpConfig = {
            method: 'POST',
            url: this.restBaseURLs.linkedDataURL,
            params: {type: 'person'},
            data: payload
        };
        return this.$http(httpConfig);
    }

    private handlePersonApiData(response) {
        this.linkedDataResponse = get(response, 'data.linkedData', []).filter(element => !has(element, 'errorMessage'));
        if (!isEmpty(this.linkedDataResponse)) {
            this.data = new LinkedDataModel(this.linkedDataResponse[0]);
            this.handlePersonFields();
            this.wikipediaPersonDescription(response);
        }
    }

    private handlePersonFields() {
        this.personFieldsToDisplay.forEach((personField) => {
            if(!isEmpty(get(this.data,personField.name+'.value',''))){                 
                personField['value'] = ('source'===personField.name) ? this.sourceTranslation : get(this.data,personField.name+'.value',''), 
                personField['label'] = get(this.data,personField.name+'.label','');                
            }
        });
        this.data['shortName'] = get(this.linkedDataResponse,'[0].person_name.wikidata','') ? get(this.linkedDataResponse,'[0].person_name.wikidata','') : get(this.linkedDataResponse,'[0].person_name.LC','');
        this.pagesTitlesService.setTitle(get(this.data,'shortName'));
    }

    public isShowDetailLine(personField){
        return !isEmpty(get(this.data,personField.name+'.value',''));
    }

    private wikipediaPersonDescription(response) {
        let wikipediaPersonName = get(response, 'data.linkedData[0].link_to_wikipedia.wikidata', '').split("/").pop();
        this.$http.get(this.WIKIPEDIA_API_URL+ wikipediaPersonName).then(
            (response) => {
                if (!isEmpty(get(response, 'data.query.pages', []))) {
                    let wikipediaPersonInfo = Object.values(response.data.query.pages)[0];
                    this.data['wikipediaPersonDescription'] = wikipediaPersonInfo.extract;
                    this.data['wikipediaPersonPageUrl'] = 'https://en.wikipedia.org/?curid=' + wikipediaPersonInfo.pageid;
                }
            }).catch(function (error) { console.log(error); });
    }

    private addPersonRelatedDataSection(data,personRelatedDataSection) {
        let personRelatedDataObject = {};
        let personRelatedDataObjectItems =  this.getPersonRelatedDataSectionItems(data);
        personRelatedDataObject['totalHits'] = get(data, 'info.total', 0);
        personRelatedDataObject['format'] = 'thumbnails';
        personRelatedDataObject['cameFrom'] = 'personPage';
        personRelatedDataObject['title'] = personRelatedDataSection.title;
        personRelatedDataObject['featuedResultsItems'] = personRelatedDataObjectItems;
        personRelatedDataSection['personRelatedDataObject'] = personRelatedDataObject;
    }

    private getPersonRelatedDataSectionItems(data: any) {
        let personRelatedDataObjectItems = [];
        get(data, 'docs', []).forEach(item => {
            personRelatedDataObjectItems.push({
                context: item.context,
                item: item,
                itemType: 'person',
                generalData: get(item, 'pnx.display.publisher[0]', ''),
                isExpanded: false,
                recordId: get(item, 'pnx.control.recordid[0]', ''),
                thumbnailLinks: this.getItemThumbnailLinks(item),
                title: get(item, 'pnx.display.title[0]', ''),
                type: get(item, 'pnx.display.type[0]', '')
            });
        });
        return personRelatedDataObjectItems;
    }

    private getItemThumbnailLinks(item) {
        let itemThumbnailLinks = Array.isArray(get(item, 'delivery.link', [])) ? get(item, 'delivery.link', []) : [get(item, 'delivery.link', [])];
        itemThumbnailLinks = itemThumbnailLinks.map(link => {return link.linkURL});

        //get syndetics thumbnails links
        let issn = get(item, 'pnx.addata.issn[0]','');
        if(!isEmpty(issn)){
            itemThumbnailLinks.push(this.SYNDETICS_THUMBNAIL_BASE_URL + '&issn=' + issn +(this.windowInfoUtils.isMobile() ? '/sc.jpg' : '/lc.jpg'));
        }else{
            let isbn = get(item, 'pnx.addata.isbn[0]','');
            if(!isEmpty(isbn)){
                itemThumbnailLinks.push(this.SYNDETICS_THUMBNAIL_BASE_URL + '&isbn=' + isbn + (this.windowInfoUtils.isMobile() ? '/sc.jpg' : '/lc.jpg'));
            }
        }
        return itemThumbnailLinks;
    }

    private getPersonRelatedDataSectionsArray(personId) {
        return [
            {   title: 'titlesBy', 
                query: 'originatingauthorid,exact,'+personId+',OR;originatingcontributorid,exact,'+personId+',AND', 
                showAllLabel: 'showAllTitlesBy' }, 
            {   title: 'titlesWrittenAbout', 
                query: 'originatingsubjectid,equals,'+personId, 
                showAllLabel: 'showAllWrittenAbout' }
        ];
    }   

    private getPersonRelatedDataSectionsData(personId) {
        let personRelatedDataPromisesArray = [];
        this.personRelatedDataSectionsArray.forEach((personRelatedDataSection,sectionIndex) => {            
            let searchParams = this.getSearchParams(0, 25, 'advanced', 'browse_search', 'date', this.institutionId, personRelatedDataSection.query);
            let personRelatedDataPromise = this.cheetah.performSearch(searchParams);
            personRelatedDataPromise.then((response) => {
                if(get(response, 'data.docs', []) && get(response, 'data.info.total', 0) > 0 ) {	
                    this.addPersonRelatedDataSection(get(response, 'data', []),personRelatedDataSection);
                }
            });
            personRelatedDataPromisesArray.push(personRelatedDataPromise);
        });  
        Promise.all(personRelatedDataPromisesArray).then((personRelatedDataResponses) => {
            this.extractRelatedPersonsIds(personRelatedDataResponses);
            this.addRelatedPersonsSection();
        });       
    }

    private extractRelatedPersonsIds(personRelatedDataResponses) {
        let relatedPersonsIds = [];
        personRelatedDataResponses.forEach((personRelatedDataResponse) => {
            get(personRelatedDataResponse, 'data.docs', []).forEach((doc) => {
                this.personPnxFields.forEach((personPnxField) => {
                    get(doc, 'pnx.addata.' + personPnxField, []).forEach((relatedPersonId) => {
                        if(this.personId !== relatedPersonId){
                            relatedPersonsIds[relatedPersonId] = relatedPersonsIds[relatedPersonId] ? relatedPersonsIds[relatedPersonId] + 1 : 1;
                        }
                    });
                });
            });
        });
        this.relatedPersonsIds = Object.keys(relatedPersonsIds).map(key => (
            { id: key, type : 'Author', count: relatedPersonsIds[key]}));
        this.relatedPersonsIds = uniqBy(this.relatedPersonsIds, 'id').sort(function (a, b) { return b.count - a.count; }).slice(0, 40);    
    }

    private addRelatedPersonsSection() {
        this.getPersonApiData({requestType: 'relatedPersons', ids: this.relatedPersonsIds})
            .then((response) => {
                let relatedPersonsSectionItems = this.getRelatedPersonsSectionItems(response);
                if(relatedPersonsSectionItems.length > 0){
                    let relatedPersonsObject = {};
                    relatedPersonsObject['totalHits'] = relatedPersonsSectionItems.length;
                    relatedPersonsObject['format'] = 'thumbnails';
                    relatedPersonsObject['cameFrom'] = 'personPage';
                    relatedPersonsObject['title'] = 'relatedPeople';
                    relatedPersonsObject['featuedResultsItems'] = relatedPersonsSectionItems;
                    this.relatedPersonsSection['title'] = 'relatedPeople';
                    this.relatedPersonsSection['relatedPersonsObject'] = relatedPersonsObject;
                }
            });
    }

    private getRelatedPersonsSectionItems(response) {
        return get(response, 'data.linkedData', [])
            .filter(element => !has(element, 'errorMessage'))
            .map((linkedData) => {
                let linkedDataModel = new LinkedDataModel(linkedData);
                return {
                    context: 'L',
                    generalData: get(linkedDataModel, 'description'),
                    personId: get(linkedDataModel, 'personId'),
                    recordId: get(linkedDataModel, 'personId'),
                    isExpanded: false,
                    type: 'book',
                    itemType: 'relatedPerson',
                    title: get(linkedDataModel, 'personName'),
                    thumbnailLinks: get(linkedDataModel, 'image.imageUrl') ? [get(linkedDataModel, 'image.imageUrl')] : []
                };
            });
    }

    private getSearchParams(offset : number, bulkSize : number, mode : string, scope : string, sortBy : string, inst : string, q : string){
        return {
            query: q,
            scope: scope,
            facets: [],
            mode: mode || 'advanced',
            offset: offset || 0,
            bulkSize: bulkSize,
            institution: inst || getInstitutionCode(),
            vid: getVid(),
            sortby: sortBy
        };
    }

    private showAllPersonRelatedData(personRelatedDataSection) {
        let searchParams = this.getSearchParams(0, 10, 'advanced', 'browse_search', 'date', this.institutionId, personRelatedDataSection.query);
        this.$state.go(STATE_NAMES.SEARCH, searchParams, {reload: false});
    }

    public performSearch(searchParams) {
        this.$state.go(STATE_NAMES.SEARCH,
			{   
                query:searchParams.mainSearchField,
                search_scope:searchParams.scopeField,
                tab: searchParams.tab,
                journals: searchParams.journals,
                databases: searchParams.databases,
                sortby:  searchParams.sortby,
                vid:this.vid,
                citationTrailFilterByAvailability: searchParams.citationTrailFilterByAvailability,
            },
            {reload: false}
		);
    }

    private isDisplayImageLicense(){
        let isDisplayImageLicense = get(this.data, 'image.licenseText', null);
        return (isDisplayImageLicense && isDisplayImageLicense != "");
    }

    private gotoWikipediaPageOnClick(){
        this.personWikipediaBeacon();
    }

    @beacon({'p':'relatedPerson', 'op':'relatedPersonWikipedia'})
    private personWikipediaBeacon() { 
    }

    private gotoCopyrightPageOnClick(){
        this.personCopyrightBeacon();
    }

    @beacon({'p':'relatedPerson', 'op':'relatedPersonCopyright'})
    private personCopyrightBeacon() { 
    }

    get copyrightLink(){
        return this.COPYRIGHT_LICENSE_URL;
    }

    public generateTitleID(personFieldToDisplayCode){
        if (personFieldToDisplayCode){
            const lastDotIndex = personFieldToDisplayCode.lastIndexOf('.');
            const lastCodePart = personFieldToDisplayCode.substring(lastDotIndex + 1);
            const capitalized = lastCodePart.charAt(0).toUpperCase() + lastCodePart.slice(1);
            return "personDetails"+capitalized;  
        }   
    }

    public isSourceValue(personFieldToDisplayName){
        return isEqual(personFieldToDisplayName,'source');
    }

    public isSourceTitleShown(){
        return document.getElementById("personDetailsSource");
    }

    get sourceTranslation() {
        return this._sourceTranslation;
    }

    set sourceTranslation(value) {
        this._sourceTranslation = value;
    }
    

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/personEntityPage/personEntityPage.directive.ts